import { isMobile, isTablet } from 'react-device-detect';

const getSafeSpacing = (value) => {
  if (isTablet) return value;
  if (isMobile) return 0;

  return value;
};

export default getSafeSpacing;
